import ROUTES from '../routes';
import Individual from '../hoc/individual';
import IndividualList from '../hoc/individual/list';
import IndividualCustomerCreate from '../hoc/individual/create-form';
import IndividualCustomerInformation from '../hoc/individual/information';
import IndividualCustomerOverview from '../hoc/individual/overview';
import OverviewCompaniesPanel from '../hoc/individual/overview/parts/companies-panel';
import CustomerStatementsTransactions from '../hoc/common/statements/transactions';
import AmlStatementsTransactions from '../hoc/common/statements/aml-transactions';
import CustomerStatementsCards from '../hoc/common/statements/cards';
import CardTransaction from '../hoc/common/statements/card-transaction';
import ProblemGLTransaction from '../hoc/common/problem-transactions/gl';
import ProblemInternalTransaction from '../hoc/common/problem-transactions/internal';
import ProblemInternalGeneralContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-general';
import ProblemInternalAmlContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-aml';
import ProblemInternalLogContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-log';
import ProblemInternalChatsContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-transaction-chats';
import ProblemInternalDocumentsContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-transaction-documents';
import ProblemIncomingTransaction from '../hoc/common/problem-transactions/incoming';
import ProblemIncomingGeneralContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-general';
import ProblemIncomingOrderContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-order';
import ProblemIncomingAmlContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-aml';
import ProblemIncomingLogContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-log';
import ProblemIncomingChangeLogContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-change-log';
import ProblemIncomingTransactionChatsContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-transaction-chats';
import ProblemIncomingTransactionDocumentsContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-transaction-documents';
import ProblemOutgoingTransaction from '../hoc/common/problem-transactions/outgoing';
import ProblemOutgoingGeneralContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-general';
import ProblemOutgoingOrderContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-order';
import ProblemOutgoingAmlContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-aml';
import ProblemOutgoingLogContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-log';
import ProblemOutgoingChangeLogContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-change-log';
import ProblemOutgoingDocumentsContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-transaction-documents';
import ProblemOutgoingTransactionChatsContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-transaction-chats';
import ProblemExchangeTransaction from '../hoc/common/problem-transactions/exchange';
import ProblemExchangeGeneralContent from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-general';
import ProblemExchangeLog from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-log';
import ProblemExchangeChangeLog from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-change-log';
import ProblemExchangeChats from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-chats';
import ProblemNostroTransaction from '../hoc/common/problem-transactions/nostro';
import ProblemNostroGeneralContent from '../hoc/common/problem-transactions/nostro/parts/problem-nostro-transaction-general';
import ProblemNostroLog from '../hoc/common/problem-transactions/nostro/parts/problem-nostro-transaction-log';
import ProblemNostroChangeLog from '../hoc/common/problem-transactions/nostro/parts/problem-nostro-transaction-change-log';
import CustomerDocuments from '../hoc/common/documents';
import CustomerDocumentInfo from '../hoc/common/documents/parts/info';
import CustomerDocumentCreate from '../hoc/common/documents/parts/create';
import CustomerStatistic from '../hoc/common/statistics';
import CustomerCards from '../hoc/common/cards';
import CustomerTariffs from '../hoc/common/tariff';
import CustomerCreateFee from '../hoc/common/tariff/fee-form';
import CustomerTransactionFromFee from '../hoc/common/tariff/transaction-from-fee';
import CustomerOrderCard from '../hoc/common/cards/order';
import IncomingTransactionWarnings from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-transaction-warnings';
import OutgoingTransactionWarnings from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-transaction-warnings';
import InternalTransactionWarnings from '../hoc/common/problem-transactions/internal/parts/problem-internal-transaction-warnings';
import InternalTransactionChangeLogs from '../hoc/common/problem-transactions/internal/parts/problem-internal-transactions-change-log';
import StatementGLTransaction from '../hoc/common/statement-gl-transaction';
import CustomerAgreement from '../hoc/common/documents/parts/agreement';
import Beneficiaries from '../hoc/common/beneficiaries';
import Beneficiary from '../hoc/common/beneficiaries/beneficiary';
import BeneficiaryContract from '../hoc/common/beneficiaries/contract';
import ExternalAccounts from '../hoc/common/external-accounts';
import CustomersExternalAccount from '../hoc/common/external-accounts/parts/account-form';
import IndividualCustomerDevices from '../hoc/individual/security/parts/devices-list';
import IndividualCustomerSecurity from '../hoc/individual/security';
import IndividualCustomerSecurityLocks from '../hoc/individual/security/parts/locks-list';
import IndividualCustomerSecurityLockForm from '../hoc/individual/security/parts/locks-form';
import IndividualCustomerSecurityLogs from '../hoc/individual/security/parts/logs-list';
import IndividualCustomerSecurityLogForm from '../hoc/individual/security/parts/logs-form';
import IndividualCustomerDeviceItem from '../hoc/individual/security/parts/device-item';
import ExhcangeTransactionComments from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-comments';
import NostroTransactionComments from '../hoc/common/problem-transactions/nostro/parts/problem-nostro-transcation-comments';
import InternalTransactionComments from '../hoc/common/problem-transactions/internal/parts/problem-internal-transaction-comments';
import IncomingTransactionComments from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-transaction-comments';
import OutgoingTransactionComments from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-transacation-comments';
import CustomerAccounts from '../hoc/common/accounts';
import CustomerExternalAccounts from '../hoc/common/external-accounts/accounts';
import CustomerLinkedClients from '../hoc/common/linked-clients';
import LinkCustomerForm from '../hoc/common/linked-clients/form';
import CustomerAML from '../hoc/common/aml';
import { OrganizationType } from '../hoc/common/types';

const IndividualCustomers = {
  path: ROUTES.CUSTOMERS_INDIVIDUAL,
  element: <Individual />,
  children: [
    {
      path: ROUTES.CUSTOMERS_INDIVIDUAL_LIST,
      element: <IndividualList />,
      children: [
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_CREATE,
          element: <IndividualCustomerCreate />,
        },
      ],
    },
    {
      path: ROUTES.CUSTOMERS_INDIVIDUAL_PAGE,
      element: <IndividualCustomerInformation />,
      children: [
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW,
          element: <IndividualCustomerOverview />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_COMPANIES,
              element: <OverviewCompaniesPanel />,
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_TRANSACTIONS,
              element: (
                <CustomerStatementsTransactions
                  customerType={OrganizationType.INDIVIDUAL}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_COMPANIES,
                  element: <OverviewCompaniesPanel />,
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_TRANSACTIONS_GL,
                  element: (
                    <StatementGLTransaction
                      customerType={OrganizationType.INDIVIDUAL}
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_CARDS,
              element: (
                <CustomerStatementsCards
                  customerType={OrganizationType.INDIVIDUAL}
                  page="overview"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_CARDS_COMPANIES,
                  element: <OverviewCompaniesPanel />,
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS,
          element: <CustomerAccounts type={OrganizationType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_TRANSACTIONS,
              element: (
                <CustomerStatementsTransactions
                  customerType={OrganizationType.INDIVIDUAL}
                  accountsPage
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_TRANSACTION_GL,
                  element: (
                    <StatementGLTransaction
                      customerType={OrganizationType.INDIVIDUAL}
                      accountsPage
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_CARDS,
              element: (
                <CustomerStatementsCards
                  customerType={OrganizationType.INDIVIDUAL}
                  page="accounts"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_CARD_TRANSACTION,
                  element: (
                    <CardTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_CARDS}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS,
          element: <ExternalAccounts type={OrganizationType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS_LIST,
              element: (
                <CustomerExternalAccounts type={OrganizationType.INDIVIDUAL} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS_CREATE,
                  element: (
                    <CustomersExternalAccount
                      type={OrganizationType.INDIVIDUAL}
                    />
                  ),
                },

                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS_ITEM,
                  element: (
                    <CustomersExternalAccount
                      type={OrganizationType.INDIVIDUAL}
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_LINKED_CLIENTS,
              element: (
                <CustomerLinkedClients type={OrganizationType.INDIVIDUAL} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_LINKED_CLIENTS_CREATE,
                  element: (
                    <LinkCustomerForm type={OrganizationType.INDIVIDUAL} />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_AML,
          element: <CustomerAML type={OrganizationType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS,
              element: (
                <AmlStatementsTransactions
                  customerType={OrganizationType.INDIVIDUAL}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_GL,
                  element: (
                    <ProblemGLTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                    />
                  ),
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE,
                  element: (
                    <ProblemExchangeTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_GENERAL
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_CHANGE_LOG
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_CHATS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_GENERAL,
                      element: <ProblemExchangeGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_LOG,
                      element: <ProblemExchangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_CHANGE_LOG,
                      element: <ProblemExchangeChangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_CHATS,
                      element: <ProblemExchangeChats />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_COMMENTS,
                      element: <ExhcangeTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO,
                  element: (
                    <ProblemNostroTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_GENERAL
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_CHANGE_LOG
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_GENERAL,
                      element: <ProblemNostroGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_LOG,
                      element: <ProblemNostroLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_CHANGE_LOG,
                      element: <ProblemNostroChangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_COMMENTS,
                      element: <NostroTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL,
                  element: (
                    <ProblemInternalTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_WARNING
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_AML
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_CHANGE_LOG
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_CHATS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_DOCUMENTS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_COMMENTS
                      }
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_GENERAL,
                      element: <ProblemInternalGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_AML,
                      element: <ProblemInternalAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_LOG,
                      element: <ProblemInternalLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_WARNING,
                      element: <InternalTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_CHANGE_LOG,
                      element: <InternalTransactionChangeLogs />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_CHATS,
                      element: <ProblemInternalChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_DOCUMENTS,
                      element: <ProblemInternalDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_COMMENTS,
                      element: <InternalTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING,
                  element: (
                    <ProblemIncomingTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING
                      }
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_AML
                      }
                      orderPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_ORDER
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_CHANGE_LOG
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_WARNINGS
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_CHATS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_DOCUMENTS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_GENERAL,
                      element: <ProblemIncomingGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_ORDER,
                      element: <ProblemIncomingOrderContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_AML,
                      element: <ProblemIncomingAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_LOG,
                      element: <ProblemIncomingLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_CHANGE_LOG,
                      element: <ProblemIncomingChangeLogContent />,
                    },

                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_WARNINGS,
                      element: <IncomingTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_CHATS,
                      element: <ProblemIncomingTransactionChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_DOCUMENTS,
                      element: <ProblemIncomingTransactionDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_COMMENTS,
                      element: <IncomingTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING,
                  element: (
                    <ProblemOutgoingTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING
                      }
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_AML
                      }
                      orderPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_ORDER
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_LOG
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_WARNINGS
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHATS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_DOCUMENTS
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHANGE_LOG
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_GENERAL,
                      element: <ProblemOutgoingGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_ORDER,
                      element: <ProblemOutgoingOrderContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_AML,
                      element: <ProblemOutgoingAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_LOG,
                      element: <ProblemOutgoingLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHANGE_LOG,
                      element: <ProblemOutgoingChangeLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_WARNINGS,
                      element: <OutgoingTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHATS,
                      element: <ProblemOutgoingTransactionChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_DOCUMENTS,
                      element: <ProblemOutgoingDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_COMMENTS,
                      element: <OutgoingTransactionComments />,
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_CARDS,
              element: (
                <CustomerStatementsCards
                  customerType={OrganizationType.INDIVIDUAL}
                  page="aml"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_CARD_TRANSACTION,
                  element: (
                    <CardTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_CARDS}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_STATISTICS,
          element: (
            <CustomerStatistic customerType={OrganizationType.INDIVIDUAL} />
          ),
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_DOCUMENTS,
          element: <CustomerDocuments type={OrganizationType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_AGREEMENT,
              element: (
                <CustomerAgreement customerType={OrganizationType.INDIVIDUAL} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_DOCUMENTS_INFO,
              element: (
                <CustomerDocumentInfo
                  customerType={OrganizationType.INDIVIDUAL}
                />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_DOCUMENTS_ADD,
              element: (
                <CustomerDocumentCreate
                  customerType={OrganizationType.INDIVIDUAL}
                />
              ),
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_CARDS,
          element: <CustomerCards type={OrganizationType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_TRANSACTION,
              element: (
                <CardTransaction backPath={ROUTES.CUSTOMERS_INDIVIDUAL_CARDS} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_ORDER,
              element: <CustomerOrderCard type={OrganizationType.INDIVIDUAL} />,
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_EDIT,
              element: <CustomerOrderCard type={OrganizationType.INDIVIDUAL} />,
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_TARIFFS,
          element: <CustomerTariffs type={OrganizationType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_TARIFFS_FEE,
              element: <CustomerCreateFee type={OrganizationType.INDIVIDUAL} />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_TARIFFS_CREATE_TRANSACTION,
                  element: (
                    <CustomerTransactionFromFee
                      type={OrganizationType.INDIVIDUAL}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_BENEFICIARIES,
          element: <Beneficiaries type={OrganizationType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_BENEFICIARY,
              element: <Beneficiary type={OrganizationType.INDIVIDUAL} />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_BENEFICIARY_CONTRACT,
                  element: (
                    <BeneficiaryContract type={OrganizationType.INDIVIDUAL} />
                  ),
                },
              ],
            },
          ],
        },

        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY,
          element: <IndividualCustomerSecurity />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES,
              element: <IndividualCustomerDevices />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES_CREATE,
                  element: (
                    <IndividualCustomerSecurityLockForm type="devices" />
                  ),
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES_ITEM,
                  element: <IndividualCustomerDeviceItem />,
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOCKS,
              element: <IndividualCustomerSecurityLocks />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOCKS_CREATE,
                  element: <IndividualCustomerSecurityLockForm type="locks" />,
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOCKS_ITEM,
                  element: <IndividualCustomerSecurityLockForm type="locks" />,
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS,
              element: <IndividualCustomerSecurityLogs />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS_CREATE,
                  element: <IndividualCustomerSecurityLockForm type="logs" />,
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS_ITEM,
                  element: <IndividualCustomerSecurityLogForm />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default IndividualCustomers;
